import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { Request } from "./utils/request";
import { RoutePath } from "@/utils/routePath";
import VueTelInput from "vue-tel-input";
import AOS from "aos";
import "aos/dist/aos.css";
import { getVatPercentage } from "@/utils/constsFromServer";

const hostname = "./api/"; //np. "https://cdif3.com/rental/api/";
getVatPercentage().then((result) => {
  app.config.globalProperties.vatRatio = (result + 100) / 100;
});
const deviceReturnDays = 7; // to w sumie tez powinno być na serwerze!!!
const globalOptions = {
  mode: "international",
  preferredCountries: ["PL", "DE", "GB", "FR", "US", "UA"],
};

let app = createApp(App);
app.config.globalProperties.hostname = hostname;
app.config.globalProperties.deviceReturnDays = deviceReturnDays;
app.config.globalProperties.request = Request;
app.config.globalProperties.routePath = RoutePath;
AOS.init();
app.use(router).use(VueTelInput, globalOptions).mount("#app");

export const useGlobals = () => app.config.globalProperties;
